/**
 * WalletOption — one row in the multi-wallet picker. Provider name/rdns are
 * wallet-supplied (untrusted with a real wallet), so they're set via
 * textContent; the icon is set via the img element's `src`, never innerHTML.
 */
export function WalletOption({ provider, onSelect }) {
  const el = document.createElement("button");
  el.className = "wallet-option";

  const icon = document.createElement("img");
  icon.src = provider.icon;
  icon.alt = "";

  const text = document.createElement("span");
  const name = document.createElement("div");
  name.className = "name";
  name.textContent = provider.name;
  const rdns = document.createElement("div");
  rdns.className = "rdns";
  rdns.textContent = provider.rdns;
  text.append(name, rdns);

  el.append(icon, text);
  el.addEventListener("click", () => onSelect(provider.uuid));
  return el;
}
